import { Translations } from '../types';

export const translations: Translations = {
  fr: {
    // Authentication
    'sign.in': 'Se connecter',
    'sign.up': 'S\'inscrire',
    'email': 'Adresse e-mail',
    'password': 'Mot de passe',
    'confirm.password': 'Confirmer le mot de passe',
    'login.success': 'Connexion réussie',
    'register.success': 'Inscription réussie',
    'logout': 'Déconnexion',
    'create.account': 'Créer un compte',
    'existing.account': 'Compte existant',
    
    // Chat
    'welcome': 'Bienvenue dans l\'Assistant SERGIC',
    'welcome.subtitle': 'Posez vos questions sur votre copropriété',
    'type.message': 'Tapez votre message...',
    'send': 'Envoyer',
    'new.conversation': 'Nouvelle conversation',
    'conversations': 'Conversations',
    'no.conversations': 'Aucune conversation',
    'start.conversation': 'Commencez une nouvelle conversation',
    'assistant.thinking': 'Assistant SERGIC réfléchit...',
    'quick.questions': 'Questions rapides',
    'quick.question.1': 'Quels sont les travaux prévus ?',
    'quick.question.2': 'Comment contacter le syndic ?',
    'quick.question.3': 'Quelles sont les charges mensuelles ?',
    'quick.question.4': 'Y a-t-il des réunions prévues ?',
    
    // Navigation
    'copropriety.assistant': 'Assistant Copropriété',
    'conversation.history': 'Historique des conversations',
    
    // Messages
    'message.sent': 'Message envoyé',
    'message.received': 'Message reçu',
    'error.message': 'Erreur lors de l\'envoi du message',
    
    // General
    'loading': 'Chargement...',
    'error': 'Erreur',
    'success': 'Succès',
    'cancel': 'Annuler',
    'save': 'Enregistrer',
    'delete': 'Supprimer',
    'edit': 'Modifier',
    'close': 'Fermer',
    'retry': 'Réessayer',
    'connection.error': 'Erreur de connexion',
    'timeout.error': 'La requête a pris trop de temps',
    'copied': 'Copié !',
    'useful': 'Utile',
    'copy': 'Copier',
  },
  en: {
    // Authentication
    'sign.in': 'Sign In',
    'sign.up': 'Sign Up',
    'email': 'Email Address',
    'password': 'Password',
    'confirm.password': 'Confirm Password',
    'login.success': 'Login successful',
    'register.success': 'Registration successful',
    'logout': 'Logout',
    'create.account': 'Create Account',
    'existing.account': 'Existing Account',
    
    // Chat
    'welcome': 'Welcome to SERGIC Assistant',
    'welcome.subtitle': 'Ask questions about your copropriety',
    'type.message': 'Type your message...',
    'send': 'Send',
    'new.conversation': 'New Conversation',
    'conversations': 'Conversations',
    'no.conversations': 'No conversations',
    'start.conversation': 'Start a new conversation',
    'assistant.thinking': 'SERGIC Assistant is thinking...',
    'quick.questions': 'Quick questions',
    'quick.question.1': 'What work is planned?',
    'quick.question.2': 'How to contact the property manager?',
    'quick.question.3': 'What are the monthly charges?',
    'quick.question.4': 'Are there any meetings scheduled?',
    
    // Navigation
    'copropriety.assistant': 'Copropriety Assistant',
    'conversation.history': 'Conversation History',
    
    // Messages
    'message.sent': 'Message sent',
    'message.received': 'Message received',
    'error.message': 'Error sending message',
    
    // General
    'loading': 'Loading...',
    'error': 'Error',
    'success': 'Success',
    'cancel': 'Cancel',
    'save': 'Save',
    'delete': 'Delete',
    'edit': 'Edit',
    'close': 'Close',
    'retry': 'Retry',
    'connection.error': 'Connection error',
    'timeout.error': 'Request timed out',
    'copied': 'Copied!',
    'useful': 'Useful',
    'copy': 'Copy',
  }
};

export const useTranslation = (language: 'fr' | 'en') => {
  return (key: string): string => {
    return translations[language][key] || key;
  };
};
